import Repository from "./Repository";

export default {
  getBidRequestsStats() {
    return Repository.get('bids_category_stats');
  },
};
